import AboutSidebar from "./AboutSidebar";
import AboutHero from "./AboutHero";
import "./About.css";

import SchoolImg from "../../utils/images/SchoolInternal.jpg";

import {
  FaCheck,
  FaChalkboardTeacher,
  FaUserGraduate,
  FaBookOpen,
  FaAward,
} from "react-icons/fa";

function KnowUs() {
  const features = [
    {
      icon: <FaChalkboardTeacher />,
      title: "Excellent Faculty",
      text: "Experienced educators dedicated to academic excellence.",
    },
    {
      icon: <FaBookOpen />,
      title: "Modern Learning",
      text: "Technology-enabled classrooms and innovative teaching methods.",
    },
    {
      icon: <FaAward />,
      title: "Strong Values",
      text: "Character building with discipline and ethical education.",
    },
    {
      icon: <FaUserGraduate />,
      title: "Personal Attention",
      text: "Individual guidance for every student's growth.",
    },
  ];

  const stats = [
    { number: "800+", label: "Students" },
    { number: "30+", label: "Faculty Members" },
    { number: "25+", label: "Years of Excellence" },
    { number: "100%", label: "Commitment" },
  ];

  return (
    <>
      <AboutHero />

      <section className="about-detail-page">
        <div className="container py-5">
          <div className="row">
            {/* Sidebar */}
            <div className="col-lg-2 mb-4">
              <AboutSidebar />
            </div>

            {/* Main Content */}
            <div className="col-lg-10">
              <div className="know-us-card">
                <div className="row align-items-center">
                  {/* Image */}
                  <div className="col-lg-5 mb-4 mb-lg-0">
                    <div className="know-us-image-wrapper">
                      <img
                        src={SchoolImg}
                        alt="IQRAA School"
                        className="know-us-image"
                      />

                      <div className="floating-badge">
                        <FaCheck />
                        Trusted Education
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="col-lg-7">
                    <span className="know-us-badge">Why Parents Choose Us</span>

                    <h2 className="know-us-title">
                      Building Bright Futures at IQRAA
                    </h2>

                    <p className="know-us-text">
                      At IQRAA Public School, education extends beyond
                      textbooks. We nurture confident, responsible, and
                      compassionate individuals through a balanced blend of
                      academics, innovation, values, and extracurricular
                      excellence.
                    </p>

                    <p className="know-us-text">
                      Our dedicated faculty, modern learning environment, and
                      student-centric approach empower children to discover
                      their talents and achieve their full potential.
                    </p>

                    {/* Stats */}
                    <div className="stats-grid">
                      {stats.map((item, index) => (
                        <div key={index} className="stat-card">
                          <h3>{item.number}</h3>
                          <p>{item.label}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Features */}
                <div className="features-section">
                  <h3 className="feature-heading">
                    What Makes IQRAA Different?
                  </h3>

                  <div className="feature-grid">
                    {features.map((item, index) => (
                      <div key={index} className="feature-card">
                        <div className="feature-icon">{item.icon}</div>

                        <div>
                          <h5>{item.title}</h5>
                          <p>{item.text}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Bottom Quote */}
                <div className="school-quote">
                  <h4>
                    "Empowering Young Minds Through Knowledge, Character &
                    Excellence."
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default KnowUs;
